import { Query } from "appwrite";

const DEFAULT_PAGE_SIZE = 100;

export async function listAllRows(tablesDB, {
  databaseId,
  tableId,
  queries = [],
  pageSize = DEFAULT_PAGE_SIZE
}) {
  const rows = [];
  let cursor = null;

  while (true) {
    const nextQueries = [...queries, Query.limit(pageSize)];

    if (cursor) {
      nextQueries.push(Query.cursorAfter(cursor));
    }

    const result = await tablesDB.listRows({
      databaseId,
      tableId,
      queries: nextQueries
    });

    const pageRows = result?.rows || [];
    rows.push(...pageRows);

    if (pageRows.length < pageSize) {
      return rows;
    }

    cursor = pageRows[pageRows.length - 1]?.$id;
    if (!cursor) {
      return rows;
    }
  }
}
